import DispatchGraphTab from "../../../dispatch/components/VehicleDispatchGraph";
import VehicleDispatchHistory from "../../../dispatch/components/VehicleDispatchHistory";
import VehicleTripCard02 from "../../../dispatch/components/VehicleTripCard";
import { Vehicle } from "../../@types";

interface TripHistoryTabProps {
  vehicleId?: string;
  driverId?: string;
  vehicle?: Vehicle;
}

const TripHistoryTab: React.FC<TripHistoryTabProps> = ({
  vehicleId,
  driverId,
  vehicle,
}) => {
  const id = vehicleId ?? driverId;
  const idType = vehicleId ? "vehicle" : "driver";
  return (
    <div className="space-y-4">
      {vehicle && <VehicleTripCard02 vehicle={vehicle} />}
      <DispatchGraphTab id={id} idType={idType} />
      <VehicleDispatchHistory id={id} idType={idType} />
    </div>
  );
};

export default TripHistoryTab;
